import auth from '@react-native-firebase/auth';
import { removeCookie } from './AuthProvider';
import { Storage } from 'fitbeat.react-native-components';

export default async function LogoutFunciton(routeToLoad) {
    removeCookie();
    auth().signOut();

    const signupError = await Storage.get('signupError', null);
    localStorage.clear();
    await Storage.clear();

    const isRouteToLoadExternalURL = routeToLoad && routeToLoad.includes('http');
    if (isRouteToLoadExternalURL) {
        window.location = routeToLoad;
        return ;
    }

    await Storage.set('signoutRoute', routeToLoad || 'AuthNavigator');
    if (signupError) {
        await Storage.set('signupError', signupError);
    }
    window.location = '/auth/login';
}
